module.exports = __webpack_public_path__ + "static/media/arrow-up.abcb3fc2.svg";